import React from "react";
import Image from "next/image";
import CommonSearch from "./ComonSearch";
import { useMediaQuery } from "react-responsive";
import { Container, Grid, Typography } from "@pmberjaya/cloudbank-ui";
import Section from "../../Common/Section";

const SearchDomain = () => {
  const isMobile = useMediaQuery({ maxWidth: 600 });

  // const urlParam=new URLSearchParams(location.search)
  return (
    <Section>
      <Grid row alignItems="center">
        <Grid md={6}>
          <h2 className="text-heading-h2">BUAT SITUS ANDA SEGERA</h2>
          <Typography className="text-paragraf">
            Kembangkan dan wujudkan usaha dan bisnis online Anda bersama kami.
          </Typography>
          <CommonSearch />
        </Grid>
        <Grid md={6} className="text-end">
          <Image
            src="/image/domain.png"
            width={350}
            height={350}
            alt="search your domain"
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default SearchDomain;
